<template>
  <div style="margin-top: 20px;">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step v-for="item of stepsList" :title="item.title" :key="item.id" />
    </el-steps>
      <!-- eslint-disable vue/no-unused-refs -->
      <allComponents ref="components"
        :active="active"
        class="component"
        @cancel="cancel"
        @previousStep="previousStep"
        @confirm="confirm"
        @submit="submit"
      />
  </div>
</template>
<script>
import config from './config'
import allComponents from './components'

export default {
  components: {
    allComponents,
  },
  data() {
    const { stepsList } = config.call(this)
    return {
      stepsList,
      active: 0,
      allParams: {},
    }
  },
  methods: {
    // 取消
    cancel() {
      this.$confirm('是否确认退出创建企业租赁主订单流程?退出后已编辑的信息将不再保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refreshBack(false)
      }).catch(() => null)
    },
    // 上一步
    previousStep() {
      this.active--
    },
    // 确认，下一步
    confirm(params) {
      this.allParams = params
      this.active++
    },
    // 提交
    submit(params) {
      this.allParams = params
      this.active++
    },
  },
}
</script>
<style scoped lang='scss'>
.component{
  margin-top: 20px;
}
</style>
